/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    '&:hover': {
      '& svg': {
        color: theme.palette.sortActive,
      },
    },
  },
  up: {
    position: 'absolute',
    top: '-1rem',
    color: theme.palette.sortInactive,
  },
  down: {
    position: 'absolute',
    top: '-.5rem',
    color: theme.palette.sortInactive,
  },
  active: {
    color: theme.palette.sortActive,
  },
  default: {
    position: 'absolute',
    color: theme.palette.sortDefault,
  },
}));

export default function SortingIcon({ sortOrder }) {
  const classes = useStyles();

  return (
    <span data-testid="sorting-test" className={classes.container}>
      <ArrowDropUpIcon
        className={clsx({ [classes.up]: true, [classes.active]: sortOrder === 'ASC', [classes.default]: !sortOrder })}
      />
      <ArrowDropDownIcon
        className={clsx({ [classes.down]: true, [classes.active]: sortOrder === 'DSC', [classes.default]: !sortOrder })}
      />
    </span>
  );
}
